import { render, staticRenderFns } from "./OcorrenciaDashboard.vue?vue&type=template&id=601ba2f8&"
import script from "./OcorrenciaDashboard.vue?vue&type=script&lang=js&"
export * from "./OcorrenciaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports